import { BKJPillDropdown, ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { SkillsSelectInputProps } from 'components/SkillsSelectInput/SkillsSelectInput.types';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export const SkillsSelectInput = ({
  name,
  value,
  onChange,
  options,
  label,
  placeholder,
  required,
  max = 20,
  disabled,
}: SkillsSelectInputProps) => (
  <ErrorBoundary componentName="SkillsSelectInput" showLogo={!WhiteLabelAccessor.isWhiteLabelled()}>
    <BKJPillDropdown
      name={name}
      value={value}
      onChange={onChange}
      options={options}
      label={label}
      placeholder={placeholder}
      required={required}
      max={max}
      disabled={disabled}
      validations={[]}
    />
  </ErrorBoundary>
);
